/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Regulamin pobytu') {
            document.title = 'Regulamin pobytu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>REGULAMIN</b></Typography>
                <Typography variant='h6' align="center"><b>	Ośrodka Szkoleniowo-Wypoczynkowego Polskiego Czerwonego Krzyża w Sławie</b></Typography>
                <br />
                
                <Typography variant='body2' gutterBottom>Niniejszy Regulamin został opracowany w celu zapewnienia bezpieczeństwa, porządku oraz komfortowego wypoczynku wszystkim Gościom Ośrodka Szkoleniowo-Wypoczynkowego Polskiego Czerwonego Krzyża w Sławie.</Typography>
                <Typography variant='body2' gutterBottom>Uprzejmie prosimy o zapoznanie się z jego treścią oraz przestrzeganie obowiązujących zasad. Przebywanie na terenie Ośrodka jest równoznaczne z akceptacją niniejszego Regulaminu.</Typography>
                    
                
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>I. PRZEPISY OGÓLNE</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Teren Ośrodka stanowi własność Polskiego Czerwonego Krzyża.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wejście na teren Ośrodka oznacza akceptację postanowień niniejszego Regulaminu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Teren Ośrodka objęty jest monitoringiem wizyjnym prowadzonym za pomocą elektronicznych środków rejestracji obrazu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Regulamin określa prawa i obowiązki Gości oraz zasady korzystania z infrastruktury, urządzeń technicznych i wyposażenia znajdującego się na terenie Ośrodka.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>II. PRZYJAZD I WYJAZD GOŚCI</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Doba pobytowa rozpoczyna się o godzinie <b>14:00</b> w dniu przyjazdu i kończy o godzinie <b>11:00</b> w dniu wyjazdu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Po przybyciu do Ośrodka Gość zobowiązany jest do dokonania formalności meldunkowych w recepcji oraz uiszczenia należności za pobyt, o ile nie została ona opłacona wcześniej.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Na dokonane płatności wystawiany jest stosowny dokument potwierdzający ich uiszczenie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Opłata miejscowa stanowi odrębną należność i nie jest wliczona w cenę pobytu. Pobierana jest w recepcji Ośrodka wyłącznie w formie gotówkowej, zgodnie z aktualnie obowiązującą stawką określoną uchwałą Rady Miejskiej właściwej dla Gminy Sława.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Do korzystania z infrastruktury Ośrodka uprawnione są wyłącznie osoby, które dopełniły formalności meldunkowych.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Każda wizyta osób odwiedzających Gości wymaga wcześniejszego zgłoszenia w recepcji Ośrodka.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Osoby odwiedzające mogą przebywać na terenie Ośrodka wyłącznie w godzinach od <b>09:00 do 21:00</b>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wstęp osób odwiedzających podlega opłacie w wysokości <b>20,00 zł od osoby</b>, niezależnie od wieku.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>III. KORZYSTANIE Z OŚRODKA</b></Typography>
                <ol type="1">
                <li><Typography variant='body2' gutterBottom>Miejsce ustawienia sprzętu campingowego, namiotów oraz pojazdów wyznacza personel Ośrodka.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zabrania się samowolnej zmiany wyznaczonego miejsca postoju bez uprzedniej zgody personelu recepcji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Przed opuszczeniem Ośrodka Gość zobowiązany jest pozostawić użytkowane miejsce w stanie niepogorszonym, uporządkowane oraz wolne od odpadów i rzeczy osobistych.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Osoby poruszające się pojazdami po terenie Ośrodka zobowiązane są do zachowania szczególnej ostrożności oraz dostosowania prędkości do warunków panujących na terenie Ośrodka.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Umywalki, prysznice, pisuary, toalety oraz pozostałe urządzenia sanitarne należy użytkować zgodnie z ich przeznaczeniem.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Podłączenia oraz odłączenia od instalacji elektrycznej mogą być wykonywane wyłącznie przez upoważnionych pracowników Ośrodka (skrzynka elektryczna na polu namiotowym).</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zwierzęta mogą przebywać na terenie Ośrodka wyłącznie pod stałą opieką właściciela lub opiekuna.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Psy muszą być prowadzone na smyczy oraz w przypadku ras wymagających szczególnej kontroli lub zachowań mogących powodować zagrożenie dla innych osób, w kagańcu.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>IV. PORZĄDEK I SPOKÓJ</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Goście zobowiązani są do przestrzegania porządku publicznego, poszanowania mienia Ośrodka oraz korzystania z niego zgodnie z przeznaczeniem.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Goście ponoszą odpowiedzialność za wszelkie szkody powstałe z ich winy lub z winy osób pozostających pod ich opieką.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Korzystanie z urządzeń odtwarzających dźwięk, instrumentów muzycznych oraz innych źródeł hałasu nie może zakłócać wypoczynku pozostałych Gości.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszelkie zauważone uszkodzenia, awarie instalacji lub sprzętu oraz przypadki naruszenia Regulaminu należy niezwłocznie zgłaszać personelowi recepcji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Na terenie Ośrodka obowiązuje cisza nocna w godzinach od <b>22:00 do 6:00.</b></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Ze względów bezpieczeństwa brama wjazdowa pozostaje zamknięta w godzinach od <b>22:00 do 6:00.</b></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wjazd i wyjazd pojazdów w czasie zamknięcia bramy możliwy jest wyłącznie w uzasadnionych, nagłych przypadkach.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>V. ZASADY BEZPIECZEŃSTWA PRZECIWPOŻAROWEGO</b></Typography>
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>Na terenie Ośrodka obowiązuje bezwzględny zakaz rozpalania ognisk.</b></Typography>
                <Typography variant='h6' style={{ fontSize: "16px" }} >Korzystanie z grilla jest dopuszczalne wyłącznie przy zachowaniu następujących zasad:</Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Grillowanie może odbywać się wyłącznie na świeżym powietrzu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Przed rozpaleniem należy upewnić się, że grill ustawiony jest stabilnie i nie stwarza ryzyka przewrócenia.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Do rozpalania grilla wolno używać wyłącznie środków przeznaczonych do tego celu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W pobliżu miejsca grillowania należy posiadać środki umożliwiające szybkie ugaszenie ognia, w szczególności wodę.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Palący się grill nie może być pozostawiony bez nadzoru osoby dorosłej.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Po zakończeniu grillowania należy upewnić się, że ogień został całkowicie ugaszony.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zabrania się wysypywania gorącego popiołu na ściółkę, trawniki lub inne powierzchnie mogące spowodować zagrożenie pożarowe</Typography></li>
                </ol>
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>Zabrania się ustawiania grilli na tarasach domków oraz w bezpośrednim sąsiedztwie materiałów łatwopalnych.</b></Typography>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>VI. POSTANOWIENIA KOŃCOWE</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>W przypadku rażącego naruszania porządku, ciszy nocnej, zasad współżycia społecznego lub postanowień niniejszego Regulaminu, kierownictwo Ośrodka zastrzega sobie prawo do natychmiastowego zakończenia pobytu Gościa bez obowiązku zwrotu opłaty za niewykorzystany okres pobytu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Ośrodek zastrzega sobie prawo odmowy przyjęcia lub kolejnego wynajmu osobom, które podczas wcześniejszych pobytów rażąco naruszały postanowienia Regulaminu bądź wyrządziły szkody w mieniu Ośrodka.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Dokonanie rezerwacji jest równoznaczne z akceptacją niniejszego Regulaminu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Regulamin obowiązuje wszystkie osoby przebywające na terenie Ośrodka, niezależnie od celu i czasu pobytu.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' style={{ fontSize: "18px" }} ><b>Dziękujemy za przestrzeganie zasad obowiązujących w Ośrodku Szkoleniowo-Wypoczynkowym Polskiego Czerwonego Krzyża w Sławie i życzymy Państwu przyjemnego pobytu.</b></Typography>


                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
                <br />
                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>Dodatkowe opłaty pobierane w recepcji w dniu przyjazdu</b></Typography>
                <br />
                <Typography variant='body2' style={{ fontSize: "16px" }} ><b>Opłata miejscowa</b></Typography>
                <ul>
                    <li><Typography variant='body2' gutterBottom>3,45 zł za osobę za dobę – zgodnie z Uchwałą Rady Miejskiej w Sławie.</Typography></li> 
                </ul>
                <Typography variant='body2' gutterBottom>Opłata płatna wyłącznie gotówką.</Typography>
                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>Parking samochodu</b></Typography>
                <ul>
                    <li><Typography variant='body2' gutterBottom>30 zł za dobę – przy pobytach krótszych niż 3 doby.</Typography></li> 
                    <li><Typography variant='body2' gutterBottom>Bezpłatnie – od 4 doby pobytu (za każdą kolejną dobę).</Typography></li> 
                    <li><Typography variant='body2' gutterBottom>Dla osób niekorzystających z usług ośrodka: 50 zł za dobę.</Typography></li> 
                </ul>
                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>Pobyt ze zwierzęciem</b></Typography>
                <ul>
                    <li><Typography variant='body2' gutterBottom>Pies, kot: 60 zł za dobę.</Typography></li> 
                </ul>



            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    bottomLabelFont: {
        fontSize: '16',
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
